import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';

export type TToastStatus = 'success' | 'warning' | 'error' | 'info' | 'attention';

interface IToast {
  text: string;
  status: TToastStatus;
  id: number;
  hideTitle?: boolean;
}
type ToastPayload = { timeout?: number; text: string | any; hideTitle?: string | any };

const defaultTimeout = 3000;

const createToast = (text: string, status: TToastStatus, hideTitle?: boolean): IToast => ({
  text,
  status,
  id: Math.random() * 1000,
  hideTitle,
});

export const useToastStore = defineStore('toast-store', () => {
  const toasts: Ref<IToast[]> = ref([]);
  function updateState(payload: ToastPayload, status: TToastStatus) {
    const { text, timeout, hideTitle } = payload;

    const toast = createToast(text, status, hideTitle);

    toasts.value.push(toast);

    setTimeout(() => {
      toasts.value = toasts.value.filter((t) => t.id !== toast.id);
    }, timeout ?? defaultTimeout);
  }
  function success(payload: ToastPayload) {
    updateState(payload, 'success');
  }

  function warning(payload: ToastPayload) {
    updateState(payload, 'warning');
  }

  function error(payload: ToastPayload) {
    updateState(payload, 'error');
  }

  function info(payload: ToastPayload) {
    updateState(payload, 'info');
  }

  function attention(payload: ToastPayload) {
    updateState(payload, 'attention');
  }

  function closeToast(id: number) {
    const index = toasts.value.findIndex((item) => item.id === id);
    if (index !== -1) {
      toasts.value.splice(index, 1);
    }
  }
  return {
    toasts,
    updateState,
    success,
    warning,
    error,
    info,
    attention,
    closeToast,
  };
});
